import { SelectionAny } from './internal';
export class SelectionPhonetization extends SelectionAny {
    getMethod() {
        return this.get("TYPE" /* Tag.Type */);
    }
}
//# sourceMappingURL=SelectionPhonetization.js.map